// eslint-disable-next-line import/prefer-default-export
export const ADD_ERRONEOUS_ELEMENT = 'canvasErrorTypes/ADD_ERRONEOUS_ELEMENT';
export const DELETE_ERRONEOUS_ELEMENT = 'canvasErrorTypes/DELETE_ERRONEOUS_ELEMENT';
